// Extend the Window interface to include _env_
declare global {
    interface Window {
        _env_?: {
            REACT_APP_API_URL?: string
            REACT_APP_ENV?: string
        }
    }
}

export type AppConfig = {
    apiPrefix: string
    onboardingEntryPath: string
    authenticatedEntryPath: string
    unAuthenticatedEntryPath: string
    tourPath: string
    locale: string
    enableMock: boolean
}

const FALLBACK_API_URL = 'https://hrm2-uidemo2-it.h2software.nl'

// Convert environment variables to proper types
const getEnv = (): string => {
    // Safely access environment variables with proper typing
    const env = globalThis.window._env_ || {}
    const apiUrl = env.REACT_APP_API_URL

    if (!apiUrl) {
        // Always visible (not gated behind dev-only logger) so a missing
        // runtime env injection is diagnosed immediately instead of silently
        // pointing the app at a hardcoded demo backend.
        // eslint-disable-next-line no-console
        console.error(
            `[app.config] window._env_.REACT_APP_API_URL is not set - falling back to ${FALLBACK_API_URL}. Check that the runtime env script is deployed.`,
        )
        return FALLBACK_API_URL
    }

    return apiUrl
}

const appConfig: AppConfig = {
    apiPrefix: getEnv(),
    onboardingEntryPath: '/on-boarding',
    authenticatedEntryPath: '/',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
    //  getEnv('VITE_FlexForce_ENABLE_MOCK', 'false').toLowerCase() === 'true',
}

export default appConfig
